const e = (e2, t, o) => ({ key: e2, type: "textSearch", ...o ? { op: o } : {}, value: t });
export {
  e as makeFilterItemTextSearch
};
//# sourceMappingURL=makeFilterItemTextSearch.js.map
